(() => {
  const initializeCollectionHeading = () => {
    document.querySelectorAll('[data-fashionlaura-collection-heading]').forEach((toolbar) => {
      const currentIsParent = toolbar.dataset.currentIsParent === 'true';
      const parentHandle = toolbar.dataset.parentHandle;
      const parentTitle = toolbar.dataset.parentTitle;
      const requestedParent = new URL(window.location.href).searchParams.get('collection_parent');

      if (!currentIsParent && parentHandle && requestedParent === parentHandle) {
        const title = toolbar.querySelector('.fashionlaura-collection-heading__title');
        const navigation = toolbar.querySelector('.fashionlaura-collection-heading__nav');
        if (title && parentTitle) title.textContent = parentTitle;
        if (navigation) navigation.hidden = false;
        toolbar.classList.add('has-parent-context');
      }

      if (requestedParent && requestedParent === parentHandle) {
        document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile, #FacetSortDrawerForm').forEach((form) => {
          if (form.querySelector('input[name="collection_parent"]')) return;
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'collection_parent';
          input.value = requestedParent;
          form.appendChild(input);
        });
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCollectionHeading);
  else initializeCollectionHeading();
})();
